module.exports = __webpack_public_path__ + "static/media/smit.766e2af6.svg";